import React, { createContext, useState } from 'react';
import * as Sebrae from '@sebrae/react-core';
import PropTypes from 'prop-types';
import { allMonthsForFilter } from '../utils/months';
import { useEmpresa } from '../../../services/empresa/EmpresaService';

export const Context = createContext({});

export const Provider = (props) => {
  // Initial values are obtained from the props
  const { children } = props;
  const { tokenInfo } = Sebrae.useAuth();
  const [empresa, setEmpresa] = useState(
    JSON.parse(localStorage.getItem(tokenInfo?.sub)),
  );

  const [empresaCpe, setEmpresaCpe] = React.useState({ notInitiated: true });
  const [boleto, setBoleto] = React.useState(null);

  const { getEmpresaCpe } = useEmpresa();

  const atualizaEmpresa = React.useCallback(
    (futureEmpresa) => {
      setEmpresa(futureEmpresa);

      localStorage.setItem(tokenInfo?.sub, JSON.stringify(futureEmpresa));
    },
    [tokenInfo],
  );

  // Make the context object:
  const appContext = {
    empresa,
    atualizaEmpresa,
    filter: {
      months: allMonthsForFilter(),
      defaultId: 2,
    },
    boleto,
    setBoleto,
    empresaCpe,
  };

  React.useEffect(() => {
    if (empresa && empresa?.cnpj) {
      getEmpresaCpe(empresa?.cnpj).then(setEmpresaCpe);
    }
  }, [empresa, getEmpresaCpe]);

  // pass the value in provider and return
  return <Context.Provider value={appContext}>{children}</Context.Provider>;
};

export const { Consumer } = Context;

Provider.propTypes = {
  children: PropTypes.shape({}).isRequired,
};
